import Constants from 'expo-constants';

/**
 * Helper function to access environment variables from Expo config
 * This provides a consistent way to access environment variables that were
 * passed through app.config.js to the runtime environment
 */

/**
 * Get environment configuration value
 * @param {string} key - The key to retrieve from environment config
 * @param {any} defaultValue - Default value if key is not found
 * @returns {any} The environment value or default value
 */
export const getEnvConfig = (key, defaultValue = null) => {
    try {
        // Try to get from Constants.expoConfig.extra first (newer Expo SDK)
        if (Constants.expoConfig?.extra?.[key] !== undefined) {
            return Constants.expoConfig.extra[key];
        }
        
        // Fallback to Constants.manifest.extra (older Expo SDK)
        if (Constants.manifest?.extra?.[key] !== undefined) {
            return Constants.manifest.extra[key];
        }
        
        // Return default value if not found
        return defaultValue;
    } catch (error) {
        console.warn(`Failed to get environment config for key: ${key}`, error);
        return defaultValue;
    }
};

/**
 * Get Soketi app key from environment configuration
 * @returns {string} Soketi app key
 */
export const getSoketiAppKey = () => {
    return getEnvConfig('soketiAppKey');
};

/**
 * Get Soketi TLS setting from environment configuration
 * @returns {string} TLS setting ('true', 'false', or 'auto')
 */
export const getSoketiForceTLS = () => {
    return getEnvConfig('soketiForceTLS', 'auto');
};

export default {
    getEnvConfig,
    getSoketiAppKey,
    getSoketiForceTLS
};
